import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { updateGoalsCollection } from '../load-goals/load-goals.function';

import { FocusSelectorUpdateSelectedGoal } from './load-goals-update.action';

export function focusSelectorUpdateGoalReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorUpdateSelectedGoal>,
): FocusSelectorState {
    const { metricId, updates } = action.payload;
    const selectedGoals = { ...state.selectedGoals };

    if (selectedGoals[metricId] == null) {
        selectedGoals[metricId] = updates;
    } else {
        selectedGoals[metricId] = {
            ...selectedGoals[metricId],
            ...updates,
        };
    }

    const udpatedGoalsCollection = updateGoalsCollection(
        selectedGoals,
        state.goalsCollection,
        state.goals,
        state.coachableMetrics,
    );

    return {
        ...state,

        selectedGoals,
        goalsCollection: udpatedGoalsCollection,
    };
}
